import request from "@/utils/request";

export function getLogsList(param) {
    return request({
        url: '/admin/search-device-log',
        method: 'GET',
        params:param
    })
}

export function getConnLogs(param) {
    return request({
        url: '/admin/search-device-conn-log',
        method: 'GET',
        params:param
    })
}